import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'
import * as THREE from "three";
import {DefaultDeviceHandler} from "./default_device_handler";

export class ThreeObserverHandler extends DefaultDeviceHandler {

    sendTimer = 200;

    raycaster = null;

    cameraOffset = {x: 0, y: 0, z: 0};

    lastSendTime = 0;
    lastSentTarget = new THREE.Vector3(0, 0, 0);

    constructor() {
        super();
        this.raycaster = new THREE.Raycaster();

        this.setupListeners();
    }

    setupListeners() {
        //TODO
    }

    animate(delta, onChange) {
        this.deviceControls.update()

        this.deviceControls.target.position = this.deviceControls.object.position
        // camera.position.copy(this.target.clone().add(this.cameraOffset))

        // this.deviceControls.object.position.set(0,5,0)
        // this.deviceControls.target.position.set(0,5,0)

        // if (this.target != null && this.lastSendTime + this.sendTimer < performance.now()) {
        //     if ((!this.target.equals(this.lastSentTarget))) {
        //         if (!this.target.equals(this.lastSentTarget)) {
        //             console.log("Position change", {
        //                 old: this.lastSentTarget,
        //                 new: this.target,
        //             })
        //         }
        //
        //         this.lastSentTarget.copy(this.target);
        //         this.lastSendTime = performance.now();
        //
        //         onChange(this.target, this.deviceControls.target)
        //     }
        //
        // }
    }

    bindControls(camera, domElement, scene) {
        camera.rotateX(Math.PI / 180);
        const cpos = camera.position.clone()

        this.deviceControls = new OrbitControls(camera, domElement);
        this.deviceControls.panSpeed = 3;
        this.deviceControls.minDistance = 15
        this.deviceControls.maxDistance = 15;
        this.deviceControls.target.set(cpos.x, cpos.y, cpos.z +1)

        this.deviceControls.update()
        this.deviceControls.minDistance = 0;
        this.deviceControls.update()


        return this.deviceControls;
    }

    isFreeFly() {
        return true;
    }

    getPosition() {
        if (this.target === null)
            return null;

        return this.target.clone()
    }

    getRotation() {
        return 0
    }

    getAngle() {
        return this.deviceControls.getAzimuthalAngle()
    }
}